import svg from './row-svg/depot-mairie.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function DepotMairieIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default DepotMairieIcon;
